import { NumberField, useListContext, useTranslate } from "react-admin"
import { InvoicesApiGetTotalInvoiceAmountsRequest, TotalInvoiceAmounts } from "../../GeneratedClients/FreeBillApi"
import { Box, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import fetchTotalAmounts from "./fetchTotalAmounts";

interface IProps {
  resource: "drafts" | "invoices"
}

const ListResults = ({resource}: IProps) => {
  const translate = useTranslate()
  const { filterValues } = useListContext()
  const [totalAmounts, setTotalAmounts] = useState<TotalInvoiceAmounts>()
  const params: InvoicesApiGetTotalInvoiceAmountsRequest = {
    pageSize: 5000,
    companyNameContains: filterValues.companyName_Contains,
    invoiceNumberContains: filterValues.invoiceNumber_Contains,
    invoiceStateEq: filterValues.invoiceState_Eq,
    grossAmountGt: filterValues.grossAmount_Gt,
    grossAmountLt: filterValues.grossAmount_Lt,
    invoiceDateGt: filterValues.invoiceDate_Gt,
    invoiceDateLt: filterValues.invoiceDate_Lt,
    dueDateGt: filterValues.dueDate_Gt,
    dueDateLt: filterValues.dueDate_Lt,
    numberRangeIdEq: filterValues.numberRangeId_Eq,
    isSendByMail: filterValues.isSendByMail,
    isCanceledEq: false
  }

  const getTotalAmounts = async() => {
    const totalAmounts = await fetchTotalAmounts(resource, params)
    setTotalAmounts(totalAmounts)
  }

  useEffect(() => {
    getTotalAmounts()
  }, [filterValues])

  if(!totalAmounts) return null

  return (
    <Box p={1} display={'flex'} justifyContent={'flex-end'} minWidth={"30%"}> 
      <Typography fontWeight={'bold'} variant="body2">
        {` ${translate("resources.invoices.netAmount")}: `} <NumberField fontWeight={'bold'} record={totalAmounts} source="totalNetAmount" options={{ style: 'currency', currency: 'EUR' }} /> | 
        {` ${translate("resources.invoices.taxAmount")}: `} <NumberField fontWeight={'bold'} record={totalAmounts} source="totalTaxAmount" options={{ style: 'currency', currency: 'EUR' }} /> | 
        {` ${translate("resources.invoices.grossAmount")}: `} <NumberField fontWeight={'bold'} record={totalAmounts} source="totalGrossAmount" options={{ style: 'currency', currency: 'EUR' }} />
      </Typography>     
    </Box>
  )
}

export default ListResults